/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".trashbtn[_ngcontent-%COMP%]{z-index:21;position:absolute}.ngxwidget[_ngcontent-%COMP%], .ngxwidget-content[_ngcontent-%COMP%]{opacity:1}"];
export { styles as styles };
